var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8818 6.47893C18.0114 6.0902 18.141 5.70146 18.141 5.18315C18.141 2.33242 15.8086 0 12.9579 0C11.0142 0 9.20008 1.16621 8.42261 2.85073C8.03387 2.72115 7.51556 2.59157 7.12682 2.59157C5.31272 2.59157 3.88736 4.01694 3.88736 5.83104C3.88736 6.0902 3.88736 6.34935 4.01694 6.47893C1.68452 6.86767 0 8.68177 0 11.0142C0 13.4762 2.07326 15.5494 4.53525 15.5494H9.0705V11.6621H5.18314L11.0142 5.83104L16.8452 11.6621H12.9579V15.5494H17.4931C19.9551 15.5494 22.0284 13.4762 22.0284 11.0142C22.0284 8.68177 20.2143 6.73809 17.8818 6.47893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadItems);
export default __webpack_public_path__ + "static/media/upload-items.5a9561262b56b9c358f1b6b6cb709b4c.svg";
export { ForwardRef as ReactComponent };